import get from 'lodash/get'
import { fromJS } from 'immutable'
import request from '../../request'
import { createAuthorization } from '../../auth'

/**
 * Get user roles from the server
 * @param {Object} options The options
 * @param {import('immutable').Map} options.auth The auth object
 * @param {String} options.server The server
 * @returns {Promise<import('immutable').Map>} The response body
 */
export async function getUserRoles (options = {}) {
  const { auth, server } = options
  const res = await request
    .get(`${server}/v1/roles`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return fromJS(get(res, 'body', {}))
}
